import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "menu-bar-show-indexes";

const MenuBarContext = createContext({
   showIndexes: false,
});

export function MenuBarProvider({ children }) {
   const [showIndexes, setShowIndexes] = useState(false);

   useEffect(() => {
      const storedValue = localStorage.getItem(STORAGE_KEY);

      if (storedValue !== null) {
         setShowIndexes(storedValue === "true");
      }
   }, []);

   useEffect(() => {
      localStorage.setItem(STORAGE_KEY, String(showIndexes));
   }, [showIndexes]);

   useEffect(() => {
      function handleKeyDown(event) {
         if (event.key === "Alt" && !event.repeat) {
            setShowIndexes((current) => !current);
         }
      }

      window.addEventListener("keyup", handleKeyDown);

      return () => {
         window.removeEventListener("keyup", handleKeyDown);
      };
   }, []);

   return (
      <MenuBarContext.Provider value={{ showIndexes }}>
         {children}
      </MenuBarContext.Provider>
   );
}

export function useMenuBar() {
   return useContext(MenuBarContext);
}
